import { getUserLocales } from "./getUserLocales.ts";

export function getDefaultLocale() {
    return getUserLocales()[0];
}
